import { call, put, select } from 'redux-saga/effects';
import { updateTokens } from "../actions/Tokens";

export function* initialize(){
    const {tokensCollection} = yield select(state => state.firebase)
    var data = [], k = 1
    const doc = yield call([tokensCollection, tokensCollection.get])
    doc.forEach((v) => {
        data.push({
            id: k,
            name_doc_id: v.id,
            ...v.data()
        })
        k++
    })
    yield put({
        type: updateTokens,
        payload: data
    })
}